var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "product-pictures-ul" },
      _vm._l(_vm.productPictures, function(item, index) {
        return _c(
          "li",
          { key: index },
          [
            _vm.productPictures.length > 1
              ? _c("a-icon", {
                  staticClass: "del-pictures",
                  attrs: { type: "close" },
                  on: {
                    click: function($event) {
                      return _vm.delPictures(index)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "Select",
              {
                attrs: { placeholder: "请选择已添加的小类", clearable: "" },
                on: {
                  "on-change": function(val) {
                    return _vm.categoryChange(val, item)
                  }
                },
                model: {
                  value: item.category2Num,
                  callback: function($$v) {
                    _vm.$set(item, "category2Num", $$v)
                  },
                  expression: "item.category2Num"
                }
              },
              _vm._l(_vm.subCategoryList, function(item) {
                return _c(
                  "Option",
                  {
                    key: item.category2Num,
                    attrs: { value: item.category2Num }
                  },
                  [
                    _vm._v(
                      _vm._s(item.category2Name) +
                        " / " +
                        _vm._s(item.category2NameEn)
                    )
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "antd-upload-box" },
              [
                _c(
                  "a-upload",
                  {
                    attrs: {
                      "list-type": "picture-card",
                      "file-list": item.fileList,
                      "before-upload": function(file) {
                        return _vm.beforeUploadHandler2(file, item)
                      },
                      remove: function(e) {
                        return _vm.handleRemove(e, item)
                      }
                    },
                    on: { preview: _vm.handlePreview }
                  },
                  [
                    item.fileList.length < 7
                      ? _c(
                          "div",
                          [
                            _c("a-icon", { attrs: { type: "plus" } }),
                            _vm._v(" "),
                            _c("div", { staticClass: "ant-upload-text" }, [
                              _vm._v("\n              上传\n            ")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: { visible: _vm.previewVisible, footer: null },
                    on: { cancel: _vm.handleCancel }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: { alt: "example", src: _vm.previewImage }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "add-pictures", on: { click: _vm.addPictures } },
      [_vm._v("添加更多")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-171fb14b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-171fb14b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/OrderScreenshot/index.vue
// module id = null
// module chunks = 